define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "forms/payout/neteller_form",
    "forms/payout/skrill_form",
    "forms/payout/sticpay_form",
    "forms/payout/bankwire_form",
    "forms/payout/bankwire_sticpay_form",
    "forms/payout/local_bankwire_form",
    "forms/payout/bankwire_sticpay_without_swift_form",
    "forms/payout/krbank_form",
    "backbone.syphon"
], function($, _, Marionette, FormErrorsBehavior, NetellerForm, SkrillForm, SticpayForm,
            BankwireForm, BankwireSticpayForm, LocalBankwireForm, BankwireSticpayWithoutSwiftForm, KrbankForm) {

    const payMethodCurrencies = {
        neteller: ['USD', 'JPY'],
        skrill: ['USD', 'EUR', 'JPY', 'GBP'],
        bankwire: ['USD', 'EUR', 'JPY', 'GBP'],
        sticpay: ['USD', 'JPY'],
        local_bankwire: ['USD']
    }

    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'accountDropdown': '#account_dropdown',
            'currencyDropdown': '#currency_abbr',

            // account's financial info
            'balance': '#balance',
            'withdrawable': '#withdrawable',

            'payMethodList': '#pay-method-list',
            
            // validation field error messages
            'fieldErrorMessage': '.help-error',

            // flash views
            'flashSuccess': '.info-box-success',
            'flashFailure': '#flash_error',

            // hidden input mt4_account_no
            'inputMt4AccountNo': '.mt4_account_no',

            // forms
            'localBankwireForm': '#local_bankwire_form',
            'netellerForm': '#neteller_form',
            'skrillForm': '#skrill_form',
            'sticpayForm': '#sticpay_form',
            'bankwireForm': '#bankwire_form',
            'krbankForm': '#krbank_form',

            // submit buttons
            'netellerSubmitButton': '#neteller_submit_button',
            'skrillSubmitButton': '#skrill_submit_button',
            'sticpaySubmitButton': '#sticpay_submit_form',
            'bankwireSubmitButton': '#bankwire_submit_form',
            'localBankwireSubmitButton': '#local_bankwire_submit_form',

            // bankwire fields
            'bankInfo': '#bank_info',
            'bankName': '#bank_name',
            'bankAccount': '#bank_account',
            'swiftCode': '#swift_code',
            'bankAccountHolder': '#bank_account_holder',
            'bankAddress': '#bank_address',
            'bankCountryDropdown': '#bank_country',

            // local_bankwire fields
            'bankCode': '#bank_code',

            "krbankSubmitButton": "#krbank_submit_form",
            "krbankAmount": "#krbank_amount",
             krbankRules: "#krbank_rules",
             krbankModalList: "#krbank_modal_list",
             withdrawalAgreeCheckbox: "#withdrawal_agree_checkbox",

        },

        events: {
            'change @ui.accountDropdown': 'requestFinancialInfo',

            'click @ui.payMethodList': 'resetForms',

            // submit button for each payment method
            'click @ui.netellerSubmitButton': 'submitNetellerForm',
            'click @ui.skrillSubmitButton': 'submitSkrillForm',
            'click @ui.sticpaySubmitButton': 'submitSticpayForm',
            'click @ui.bankwireSubmitButton': 'submitBankwireForm',
            'click @ui.localBankwireSubmitButton': 'submitLocalBankwireForm',

            // bankwire info update
            'change @ui.bankInfo': 'updateBankDetails',
            'change @ui.bankCountryDropdown': 'reloadPage',

            'click @ui.krbankSubmitButton': 'submitKrbankForm',

            "keyup @ui.krbankAmount": "validateKrbankAmount",
            "click @ui.withdrawalAgreeCheckbox": "onoff_agree_checkbox",
            "click @ui.krbankModalList": "openKrbankModal",
        },

        initialize: function() {
            this.bindUIElements();
            this.setCurrencyDropdownOptions();

            $("#error_amount").text("");
        },

        reloadPage: function() {
            const countryCode = this.ui.bankCountryDropdown.val()
            let url = window.location.href;
            if(window.location.href.includes('?')) {
                url = window.location.href.split('?')[0]
            }
            window.location.href = url + "?bank_country=" + countryCode;
        },

        resetForms: function() {
            this.ui.flashSuccess.hide();
            this.ui.flashFailure.hide();
            this.ui.fieldErrorMessage.empty();
        },

        setCurrencyDropdownOptions: function () {
            const that = this;
            const netellerCurrencyDropdown = that.ui.netellerForm.find('.currency_abbr');
            const skrillCurrencyDropdown = that.ui.skrillForm.find('.currency_abbr');
            const sticpayCurrencyDropdown = that.ui.sticpayForm.find('.currency_abbr');
            const bankwireCurrencyDropdown = that.ui.bankwireForm.find('.currency_abbr');
            payMethodCurrencies['neteller'].forEach(currency => {
                netellerCurrencyDropdown.append(new Option(currency, currency));
            });
            payMethodCurrencies['skrill'].forEach(currency => {
                skrillCurrencyDropdown.append(new Option(currency, currency));
            });
            payMethodCurrencies['sticpay'].forEach(currency => {
                sticpayCurrencyDropdown.append(new Option(currency, currency));
            });

            if(window.pay_method === 'bankwire_sticpay')
            {
                bankwireCurrencyDropdown.append(new Option(window.sticpay_currency, window.sticpay_currency));
            }
            else
            {
                payMethodCurrencies['bankwire'].forEach(currency => {
                    bankwireCurrencyDropdown.append(new Option(currency, currency));
                });
            }
        },

        requestFinancialInfo: function() {
            const that = this;
            that.ui.inputMt4AccountNo.val(that.ui.accountDropdown.val());
            $.ajax({
                url: '/rest_payout/get_financial_info',
                data:{
                    account_no: that.ui.accountDropdown.val(),
                    currency: that.ui.currencyDropdown.val()
                },

                success: function(data, res){
                    that.ui.balance.html(data.currency_symbol+' '+data.balance);
                    that.ui.withdrawable.html(data.currency_symbol+' '+data.withdrawable);
                },
            })
        },

        submit: function(jsForm, uiForm) {
            const that = this;
            that.triggerMethod('hide:errors');

            let formData = Backbone.Syphon.serialize(uiForm);
            jsForm.set(formData);

            const errors = jsForm.validate();

            if(_.size(errors) < 1)
            {
                jsForm.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        uiForm.submit();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                        $('.submit_action').prop('disabled', false);
                    }
                });
            }
            else
            {
                that.triggerMethod('show:errors', errors);
                $('.submit_action').prop('disabled', false);
            }
        },

        submitNetellerForm: function(e) {
            if(e) e.preventDefault();
            this.submit(new NetellerForm(), this.ui.netellerForm);
        },

        submitSkrillForm: function(e) {
            if(e) e.preventDefault();
            this.submit(new SkrillForm(), this.ui.skrillForm);
        },

        submitSticpayForm: function(e) {
            if(e) e.preventDefault();
            this.ui.sticpaySubmitButton.prop('disabled', true);
            this.submit(new SticpayForm(), this.ui.sticpayForm);
        },

        submitBankwireForm: function(e) {
            if(e) e.preventDefault();
            this.ui.bankwireSubmitButton.prop('disabled', true);

            let form;
            if(window.pay_method == 'bankwire_sticpay' && window.is_sticpay_view == true) {
                form = new BankwireSticpayWithoutSwiftForm()
            } else {
                form  = new BankwireSticpayForm();
            }

            this.submit(form, this.ui.bankwireForm);
        },

        submitLocalBankwireForm: function(e) {
            if(e) e.preventDefault();
            this.ui.localBankwireSubmitButton.prop('disabled', true);
            this.submit(new LocalBankwireForm(), this.ui.localBankwireForm);
        },

        submitKrbankForm: function(e) {
            if(e) e.preventDefault();
            this.ui.krbankSubmitButton.prop('disabled', true);

            this.submit(new KrbankForm(), this.ui.krbankForm);
        },


        validateKrbankAmount: function (e) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function () {
                const amount = $("#krbank_amount").val();
                if (isNaN(amount) || amount === "" || !amount) {
                    $("#expected_amount").val("-");
                    return;
                }

                $("#error_amount").text("");
                $("#expected_amount").val("-");

                const min_amount = window.min_amount;
                const max_amount = window.max_amount;
                const daily_withdrawal_limit = window.daily_withdrawal_limit;
                const yearly_withdrawal_limit = window.yearly_withdrawal_limit;

                // 1. check min amount
                if (amount < min_amount) {
                    $("#expected_amount").text("-");
                    $("#krbank_submit_form").attr("disabled", true);
                    $("#error_amount").text(
                        window.translations.error_krbank_withdrawal_min_amount
                    );
                    return;
                }

                // 2. check max amount
                if (amount > max_amount) {
                    $("#expected_amount").text("-");
                    $("#krbank_submit_form").attr("disabled", true);
                    $("#error_amount").text(
                        window.translations.error_krbank_withdrawal_max_amount
                    );
                    return;
                }

                // 3. check daily max amount
                if (amount > daily_withdrawal_limit) {
                    $("#expected_amount").text("-");
                    $("#krbank_submit_form").attr("disabled", true);
                    $("#error_amount").text(
                        window.translations.error_krbank_withdrawal_daily_limit
                    );
                    return;
                }

                // 4. check yearly max amount
                if (amount > yearly_withdrawal_limit) {
                    $("#expected_amount").text("-");
                    $("#krbank_submit_form").attr("disabled", true);
                    $("#error_amount").text(
                        window.translations.error_krbank_withdrawal_annual_limit
                    );
                    return;
                }

                $.ajax({
                    url: `/rest_payout/calculate_krbank_expected_amount?amount=${amount}`,
                    type: "GET",
                    success: function (data) {
                        $("#expected_amount").text("₩" + data.expected_krw_amount_format);
                        if ($("#withdrawal_agree_checkbox").is(":checked")) {
                            $("#krbank_submit_form").attr("disabled", false);
                        } else {
                            $("#krbank_submit_form").attr("disabled", true);
                        }
                    },
                });
            }, 300);
        },

        onoff_agree_checkbox: function (e) {
            const $checkbox = $("#withdrawal_agree_checkbox");
            if ($checkbox.is(":checked")) {
                this.validateKrbankAmount();
            } else {
                $("#krbank_submit_form").attr("disabled", true);
            }
        },

        updateBankDetails: function(e){
            if(e) e.preventDefault();

            var bankDetails = window.banks_list[this.ui.bankInfo.val()];

            if(bankDetails){
                this.ui.bankName.val(bankDetails.bank_name);
                this.ui.bankAccount.val(bankDetails.bank_account);
                this.ui.swiftCode.val(bankDetails.swift_code);
                this.ui.bankAccountHolder.val(bankDetails.bank_account_holder);
                this.ui.bankAddress.val(bankDetails.bank_address);
            }else{
                this.ui.bankName.val('');
                this.ui.bankAccount.val('');
                this.ui.swiftCode.val('');
                this.ui.bankAccountHolder.val('');
                this.ui.bankAddress.val('');
            }
        },

        openKrbankModal: function() {
            $(this.ui.krbankRules).modal('show');
        },
    });

});
